'use client'

import { toast } from "@/hooks/use-toast"
import useCommonStore from "@/store/commonStore"
import useUserOrderedStore from "@/store/userOrderedStore"
import { zodResolver } from "@hookform/resolvers/zod"
import { useEffect, useMemo, useState } from "react"
import { useForm } from "react-hook-form"
import z from "zod"

export default function EditProfile({ onClose,translations }: { onClose: () => void ,translations:any}) {
    //   const { fetchUserProfile, updateUserProfile } = useUserOrderedStore()
    //       const { user } = useCommonStore()

    const { updateUserProfile, userDetails, fetchUserProfile } = useUserOrderedStore()
    const { user } = useCommonStore()
    const [loading, setLoading] = useState(false)

    const defaultValues = useMemo(() => ({
        fname: user?.fname || "",
        lname: user?.lname || "",
        phn_num: user?.phn_num || "",
        email: user?.email || "",
        gnd: user?.gnd || "",
        dob: user?.dob || "",
        locality: user?.locality || "",
        phn_cd: user?.phn_cd || "",
        alt_phn_num: user?.alt_phn_num || "",
        uid: user?.uid
    }), [user])

    const validationSchema = useMemo(() => z.object({
        fname: z.string().nonempty("First Name is required"),
        lname: z.string().nonempty("Last Name is required"),
        phn_num: z.string().nonempty("Phone number is required"),
        phn_cd: z.string().min(1, "Phone code is required").max(100),
        email: z.string().max(100).email("Invalid email").or(z.literal("")).nullable().optional(),    
        gnd: z.string().optional(),
        dob: z.string().optional(),
        locality: z.string().optional(),
        alt_phn_num: z.string().min(0, "Phone number is required").optional(),
        uid: z.string().max(100),
    }), [])

    type FormType = z.infer<typeof validationSchema>

    const { register, handleSubmit, formState: { errors }, reset } = useForm<FormType>({
        defaultValues,
        resolver: zodResolver(validationSchema)
    })

    useEffect(() => {
        if (userDetails) {
            reset(userDetails)
        }
    }, [userDetails, reset])

    const onSubmit = async (data: FormType) => {
        setLoading(true)
        data.uid = userDetails?.uid
        const result = await updateUserProfile(data)
        setLoading(false)

        if (result?.status) {
            await fetchUserProfile()
            toast({ title: "Success", description: result?.message })
            onClose()
        } else {
            toast({
                title: "Error",
                description: result?.error || result?.message,
                variant: "destructive"
            })
        }
    }

    return (
        <div className="max-w-xl bg-white rounded-xl p-3 shadow">
            <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
                <div className="flex gap-4">
                    <div className="flex-1">
                        <label className="block text-sm mb-1">{translations["frst_nm"]||"First name"}</label>
                        <input className="w-full border rounded px-3 py-2" {...register("fname")} />
                        {errors?.fname && <p className="text-red-500 text-xs mt-1">{errors.fname.message}</p>}
                    </div>
                    <div className="flex-1">
                        <label className="block text-sm mb-1">{translations["lst_nm"]||"Last name"}</label>
                        <input className="w-full border rounded px-3 py-2" {...register("lname")} />
                        {errors?.lname && <p className="text-red-500 text-xs mt-1">{errors.lname.message}</p>}
                    </div>
                </div>

                <div>
                    <label className="block text-sm mb-1">{translations["mbl_nm"]||"Mobile number"}</label>
                    <input className="w-full border rounded px-3 py-2" disabled={true} {...register("phn_num")} />
                    {errors?.phn_num && <p className="text-red-500 text-xs mt-1">{errors.phn_num.message}</p>}
                </div>

                <div>
                    <label className="block text-sm mb-1">{translations["email"]||"Email ID"}</label>
                    <input className="w-full border rounded px-3 py-2"  {...register("email")} />
                    {errors?.email && <p className="text-red-500 text-xs mt-1">{errors.email.message}</p>}
                </div>

                <div className="flex gap-4">
                    <div className="flex-1">
                        <label className="block text-sm mb-1">{translations["gndr"]||"Gender"}</label>
                        <select className="w-full border rounded px-3 py-2" {...register("gnd")}>
                            <option value="">{translations["select"]||"Select"}</option>
                            <option value="male">{translations["male"]||"Male"}</option>
                            <option value="female">{translations["femail"]||"Female"}</option>
                            <option value="other">{translations["other"]||"Other"}</option>
                        </select>
                        {errors?.gnd && <p className="text-red-500 text-xs mt-1">{errors.gnd.message}</p>}
                    </div>

                    {/* <div className="flex-1">
                        <label className="block text-sm mb-1">{translations["dob"]||"Date of birth"}</label>
                        <input type="date" className="w-full border rounded px-3 py-2" {...register("dob")} max={new Date().toISOString().split("T")[0]} />
                        {errors?.dob && <p className="text-red-500 text-xs mt-1">{errors.dob.message}</p>}
                    </div> */}
                </div>

                <div>
                    <label className="block text-sm mb-1">{translations["alt_num"]||"Alternate Mobile"}</label>
                    <input className="w-full border rounded px-3 py-2" {...register("alt_phn_num")} />
                    {errors?.alt_phn_num && <p className="text-red-500 text-xs mt-1">{errors.alt_phn_num.message}</p>}
                </div>

                <div className="flex gap-3">
                    <button type="submit" disabled={loading} className="bg-primary text-white px-6 py-2 rounded font-semibold mt-2">
                        {loading ? "Updating..." : "Update Profile"}
                    </button>
                    <button type="button" className="bg-gray-200 text-gray-700 px-6 py-2 rounded font-semibold mt-2" onClick={onClose}>
                        {translations["cancel"]||"Cancel"}
                    </button>
                </div>
            </form>
        </div>
    )
}


// import { toast } from "@/hooks/use-toast"
// import useCommonStore from "@/store/commonStore"
// import useUserOrderedStore from "@/store/userOrderedStore"
// import { zodResolver } from "@hookform/resolvers/zod"
// import { useEffect, useMemo, useRef, useState } from "react"
// import { useForm } from "react-hook-form"
// import z from "zod"

// export function AddAddress({ open, onClose }: { open: boolean, onClose: () => void }) {
//     const [show, setShow] = useState(open)
//     const modalRef = useRef<HTMLDivElement>(null)
//     const [loading, setLoading] = useState(false)
//     const { countries, user, fetchCountries, fetchAddressList } = useCommonStore()
//     const { fetchUserProfile, userDetails, updateUserProfile } = useUserOrderedStore()

//     const defaultValues = useMemo(() => ({
//         fname: "",
//         lname: "",
//         phn_num: user?.phn_num || "",
//         email: user?.email || "",
//         gnd: "",
//         dob: "",
//         locality: "",
//         phn_cd: "",
//         alt_phn_num: ""
//     }), [user])


//     const validationSchema = useMemo(() => z.object({
//         fname: z.string().min(1, "First name is required").max(100),
//         lname: z.string().min(1, "Last name is required").max(100),
//         phn_num: z.string().min(2, "Phone number is required").max(100),
//         phn_cd: z.string().min(1, "Phone code is required").max(100),
//         email: z.string().email("Invalid email").max(100).optional(),
//         gnd: z.string().min(2, "Gender is required").max(100),
//         dob: z.string().min(2, "Dob is required").max(100),
//         locality: z.string().max(100).optional(),
//         alt_phn_num: z.string().min(2, "Phone number is required").optional(),
//     }), []);
//     type FormType = z.infer<typeof validationSchema>

//     useEffect(() => {
//         if (open) {
//             setShow(true)
//             loadDetails
//         }
//         else {
//             const timeout = setTimeout(() => setShow(false), 300)
//             return () => clearTimeout(timeout)
//         }

//     }, [open])

//     const loadDetails = async () => {
//         setLoading(true)
//         const result = await fetchUserProfile()
//         setLoading(false)
//         if (result?.status) {
//             reset(result.data)
//         } else {
//             toast({
//                 title: "Error",
//                 description: result?.error || result?.message,
//                 variant: "destructive"
//             })
//         }
//     }

//     const { register, control, handleSubmit, formState: { errors }, setValue, reset } = useForm<FormType>({
//         defaultValues,
//         resolver: zodResolver(validationSchema)
//     })

//     const onSubmit = async (data: FormType) => {
//         setLoading(true)
//         let result;

//         result = await updateUserProfile(data)

//         setLoading(false)
//         if (result?.status) {
//             onClose()
//             await fetchAddressList()
//             toast({
//                 title: "Success",
//                 description: result?.message,
//                 variant: "default"
//             })
//         } else {
//             toast({
//                 title: "Error",
//                 description: result?.error || result?.message,
//                 variant: "destructive"
//             })
//         }
//     }

//     return (
//         (
//             <div
//                 className={`fixed inset-0 z-[99] bg-black/40 flex items-end md:items-center justify-center transition-opacity duration-300 pt-4 ${open ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}
//                 style={{ scrollBehavior: 'smooth' }}
//             >
//                 <div
//                     ref={modalRef}
//                     className={`bg-white w-full h-full max-w-md md:max-w-lg md:h-auto rounded-t-2xl md:rounded-2xl shadow-lg relative overflow-y-auto transition-transform duration-300 pt-4 relative
//         ${open ? 'translate-y-0 md:scale-100' : 'translate-y-full md:scale-95'}`}
//                 >
//                     <form method='POST' onSubmit={handleSubmit(onSubmit)} className=" relative"
//                     // className="space-y-4"
//                     // onSubmit={e => {
//                     //     e.preventDefault()
//                     //     setEditMode(false)
//                     // }}
//                     >
//                         <div className="flex gap-4">
//                             <div className="flex-1">
//                                 <label htmlFor="firstName" className="block text-sm mb-1">First name</label>
//                                 <input autoComplete='off' id="firstName" className="w-full border rounded px-3 py-2"  {...register("fname")} />
//                                 {errors?.fname && <p className="text-red-500 text-xs mt-1">{errors.fname.message}</p>}
//                             </div>
//                             <div className="flex-1">
//                                 <label htmlFor="lastName" className="block text-sm mb-1">Last name</label>
//                                 <input id="lastName" className="w-full border rounded px-3 py-2" {...register("lname")} />
//                                 {errors?.lname && <p className="text-red-500 text-xs mt-1">{errors.lname.message}</p>}
//                             </div>
//                         </div>
//                         <div>
//                             <label htmlFor="mobile" className="block text-sm mb-1">Mobile number</label>
//                             <input id="mobile" className="w-full border rounded px-3 py-2" {...register("phn_num")} />
//                             {errors?.phn_num && <p className="text-red-500 text-xs mt-1">{errors.phn_num.message}</p>}
//                         </div>
//                         <div>
//                             <label htmlFor="email" className="block text-sm mb-1">Email ID</label>
//                             <input id="email" className="w-full border rounded px-3 py-2" {...register("email")} />
//                             {errors?.email && <p className="text-red-500 text-xs mt-1">{errors.email.message}</p>}

//                         </div>
//                         <div className="flex gap-4">
//                             <div className="flex-1">
//                                 <label htmlFor="gender" className="block text-sm mb-1">Gender</label>
//                                 <select id="gender" className="w-full border rounded px-3 py-2" {...register("gnd")}>
//                                     <option value="">Select</option>
//                                     <option value="male">Male</option>
//                                     <option value="female">Female</option>
//                                     <option value="other">Other</option>
//                                 </select>
//                                 {errors?.gnd && <p className="text-red-500 text-xs mt-1">{errors.gnd.message}</p>}
//                             </div>

//                             <div className="flex-1">
//                                 <label htmlFor="dob" className="block text-sm mb-1">Date of birth</label>
//                                 <input
//                                     id="dob"
//                                     type="date"
//                                     className="w-full border rounded px-3 py-2"
//                                     {...register("dob")}
//                                 />
//                                 {errors?.dob && <p className="text-red-500 text-xs mt-1">{errors.dob.message}</p>}
//                             </div>
//                         </div>
//                         <div>
//                             <label htmlFor="location" className="block text-sm mb-1">Location</label>
//                             <input id="location" className="w-full border rounded px-3 py-2" {...register("locality")} />
//                             {errors?.locality && <p className="text-red-500 text-xs mt-1">{errors.locality.message}</p>}

//                         </div>
//                         <div>
//                             <label htmlFor="altMobile" className="block text-sm mb-1">Alternate Mobile</label>
//                             <input id="altMobile" className="w-full border rounded px-3 py-2" {...register("alt_phn_num")} />
//                             {errors?.alt_phn_num && <p className="text-red-500 text-xs mt-1">{errors.alt_phn_num.message}</p>}

//                         </div>
//                         <div className="flex gap-3">
//                             <button type="submit" className="bg-primary text-white px-6 py-2 rounded font-semibold mt-2">
//                                 Update Profile
//                             </button>
//                             <button
//                                 type="button"
//                                 className="bg-gray-200 text-gray-700 px-6 py-2 rounded font-semibold mt-2"
//                                 onClick={() => setEditMode(false)}
//                             >
//                                 Cancel
//                             </button>
//                         </div>
//                     </form>
//                 </div>
//             </div>
//         )
//     )
// }